import script from "./Tags.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tags.vue?vue&type=script&lang=ts&setup=true"

import "./Tags.vue?vue&type=style&index=0&id=f9418f56&lang=css"

const __exports__ = script;

export default __exports__